import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import ErrorBoundary from '../error-boundary';
import NavBar from './nav-bar/nav-bar';
import CategoryNavRibbon from '../category-nav-ribbon/category-nav-ribbon';
import SimpleHeader from './simple-header/simple-header';
import type { ShellState } from '../reducers/common';

const Header = () => {
    const { showSimpleHeaderOnly } = useSelector((state: ShellState) => ({
        showSimpleHeaderOnly: state.baseConfig?.showSimpleHeaderOnly,
    }));

    return (
        <Fragment>
            <ErrorBoundary>
                <header className="header">
                    {showSimpleHeaderOnly ? (
                        <SimpleHeader />
                    ) : (
                        <>
                            <NavBar />
                            <CategoryNavRibbon />
                        </>
                    )}
                </header>
            </ErrorBoundary>
        </Fragment>
    );
};

export default Header;
